<template>
  <div>
    <el-row type="flex" justify="end" class="title-bar">
      <div class="vertical-center-box">
        <el-button class="mr-r5" size="small" @click="onClickExportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"/>
      </div>
    </el-row>
    <el-row>
      <el-table-wrapper
        v-loading="isLoading"
        ref="accessPointTable"
        border
        :data="tableDatas"
        :columns="controllerColumns"
        :show-custom-header="true"
        :show-search-tool="showSearchTool"
        :show-overflow-tooltip="true"
        :pagination="true"
        :remote="true"
        :total="tableTotal"
        :column-default="columnDefault"
        @condition-change="onChangeTable"
      >
        <template #obj-name-slot="scope">
          <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{ scope.row.objName }}</span>
          <span v-else>-</span>
        </template>
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty, isNil } from 'lodash';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import { objtype } from '@/constants/objtype';
import { routePathByObjId } from '@/utils/router';
import fileApi from '@/api/common/file';
import msgUtil from '@/utils/message';
import wirelessAPI from '@/api/config/wireless-device/wireless-device-info';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';

export default {
  name: 'WAccessPointConfigTable',
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      columnDefault,
      isLoading: false,
      showSearchTool: false,
      tableDatas: [],
      tableTotal: 0,
      controllerColumns: [
        { prop: 'objName', label: '장비명', scopedSlot: 'obj-name-slot', headerAlign: 'center', sortable: true, searchable: true, remoteProp: 'o.obj_name', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'ipaddress', label: 'IP', headerAlign: 'center', sortable: true, searchable: true, width: 120, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'objMacaddress', label: 'MAC', remoteProp: 'o.obj_macaddress', headerAlign: 'center', sortable: true, searchable: true, width: 120, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'objCompanyName', remoteProp: 'oc.obj_company_name', label: '제조사', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'objProductId', remoteProp: 'o.obj_product_id', label: '모델명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'ssid', label: 'WLAN', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'radioBand', label: '주파수 대역', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'apGroup', label: 'AP 그룹', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'controllerName', remoteProp: 'controllerInfo.obj_name', label: '컨트롤러', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'osVersion', remoteProp: 'ncmInfo.osVersion', label: 'OS 버전', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'netdeviceUptimeCount', label: '구동 시간', sortable: true, searchable: false, formatter: this.convertNetdeviceUptime },
      ],
      params: {
        managegroupIds: null,
      },
    };
  },
  computed: {
    customerId() {
      return this.$store.state.common.customerId;
    },
    ...mapGetters(['selectedNode', 'selectedObjDefineIds', 'selectedObjDefineIdsForPhysical']),
  },
  watch: {
    selectedNode: {
      handler() {
        if (this.$refs.accessPointTable === undefined) {
          this.$nextTick(() => {
            this.loadData();
          });
        } else {
          this.loadData();
        }
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadData();
      },
    },
  },
  methods: {
    onChangeTable() {
      this.loadData();
    },
    loadData() {
      if (this.active) {
        const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
        const tableParams = this.$refs.accessPointTable.getParameter();
        this.isLoading = true;
        const params = {
          ...this.params,
          ...tableParams,
          managegroupIds: this.selectedNode.childManagegroupIds,
          treeType,
          objtypeId: objtype.WIRELESS_AP,
          managetypeId: this.selectedNode.managetypeId,
        };
        if (!isEmpty(this.selectedObjDefineIds)) {
          params.objDefineIds = this.selectedObjDefineIds;
        }
        wirelessAPI
          .getWirelessApConfigInfoList(params)
          .then((response) => {
            if (response.data.success) {
              this.tableDatas = response.data.data;
              this.tableTotal = response.data.total;
            }
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '무선 AP 구성 정보', false));
            throw new Error(e);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    clickObjName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
    convertNetdeviceUptime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return `${value}일`;
    },
    /**
     * [onClickExportExcel AP 구성 정보를 엑셀 출력한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    onClickExportExcel() {
      const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
      const tableParams = this.$refs.accessPointTable.getParameter();
      const params = {
        ...this.params,
        ...tableParams,
        managegroupIds: this.selectedNode.childManagegroupIds,
        treeType,
        objtypeId: objtype.WIRELESS_AP,
        managetypeId: this.selectedNode.managetypeId,
      };
      if (!isEmpty(this.selectedObjDefineIds)) {
        params.objDefineIds = this.selectedObjDefineIds;
      }
      wirelessAPI
        .exportWirelessApConfigInfoList(params)
        .then((response) => {
          if (response.data.success && response.data.data) {
            fileApi.downloadExportedExcelFile(response.data.data);
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/config/group/wireless/components/AccessPointConfigTable.vue